"use strict";

class StationSettingsSlaveCtrl {

    constructor($rootScope, $http, $scope, $mdToast)
    {
        this.$rootScope = $rootScope;

        this.$http = $http;
        this.$mdToast = $mdToast;

        this.stations = [];

        this.stationKey = null;
        this.stationSecret = null;

        this.fetch();

        this.$rootScope.saveHiden = true;

    }

    fetch() {
        this.$http.get('/station/masterstations').then(response => {
            this.stations = response.data;
        });
    }

    deleteStation(key) {
        this.$http.post('/station/leavemasterstation/' + key).then(response => {
            this.fetch();
        });
    }

    addMaster() {
        this.stationSettings =
            {
                stationKey: this.stationKey,
                stationSecret: this.stationSecret
            };

        this.$http.post('/station/joinstation', this.stationSettings).then(response => {
            this.fetch();
        });
    }

}

StationSettingsSlaveCtrl.$inject = [
    '$rootScope',
    '$http',
    '$scope',
    '$mdToast'
];

module.exports = StationSettingsSlaveCtrl;